import { render, staticRenderFns } from "./serviceCharge.vue?vue&type=template&id=38919aef&"
import script from "./serviceCharge.vue?vue&type=script&lang=js&"
export * from "./serviceCharge.vue?vue&type=script&lang=js&"
import style0 from "./serviceCharge.vue?vue&type=style&index=0&id=38919aef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports